import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  kycWarningMessage: null,
  certificateWarningMessage: null,
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setShowKycWarning: (state, action) => {
      state.kycWarningMessage = action.payload;
    },
    clearKycWarning: (state) => {
      state.kycWarningMessage = null;
    },
    setShowCertificateWarning: (state, action) => {
      state.certificateWarningMessage = action.payload;
    },
    clearCertificateWarning: (state) => {
      state.certificateWarningMessage = null;
    },
  },
});

export const { setShowKycWarning, clearKycWarning,setShowCertificateWarning,clearCertificateWarning } = uiSlice.actions;
export default uiSlice.reducer;
